import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { FormCategoryService } from '../form-category.service';

interface GetFormCategoriesParams {
	page?: number;
	limit?: number;
}

export const useGetFormCategories = (
	params?: GetFormCategoriesParams,
	options?: Omit<
		UseQueryOptions<Forms.PaginatedFormCategories, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['form-categories', params],
		queryFn: () => FormCategoryService.getAll(params),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetFormCategory = (
	id: string,
	options?: Omit<
		UseQueryOptions<Forms.FormCategoryCatalog, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['form-category', id],
		queryFn: () => FormCategoryService.getById(id),
		enabled: !!id,
		refetchOnWindowFocus: false,
		...options,
	});
};
